import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { displayCelestialCoords } from '../utils/displayCelestialCoords';

function Hardware(props) {
  const { mountData, sitech, domeData, qstat, svcstat, acam_C } = props;

  // CAM
  const { cam } = svcstat;
  const qstats = qstat.split(' ');

  let acam_C_string = `Temp: ${Math.floor(acam_C * 10) / 10}°`;
  let cam_state = '';

  if (qstats[0] === 'OBSERVING' || qstats[0] === 'EXPOSING') {
    if (cam === 'BUSY') {
      cam_state = 'EXPOSING';
      acam_C_string = '';
    } else if (cam === 'IDLE') {
      cam_state = 'IDLE';
    }
  } else if (qstats[0] === 'SLEWING' && cam === 'BUSY') {
    cam_state = 'READOUT';
  } else {
    cam_state = 'IDLE';
  }

  // MOUNT
  const { slewing, tracking, blinky } = sitech;
  const { ra_deg, dec_deg, az_deg, alt_deg } = mountData;

  const radec = displayCelestialCoords(ra_deg, dec_deg);
  const azalt = `Az: ${az_deg} Alt: ${alt_deg}`;
  let mount_state = '';

  if (tracking === 0 && slewing === 0) {
    mount_state = 'IDLE';
  }
  else if (tracking === 1) {
    mount_state = 'TRACKING';
  }
  else if (slewing === 1) {
    mount_state = 'SLEWING';
  }
  else if (blinky === 1) {
    mount_state = 'BLINKY MODE';
  }

  // DOME
  const { shutter, status } = domeData;
  const daz_deg = Math.floor(domeData.az_deg);
  var dstat = status.split(' ');

  let move;
  if (dstat[1] === 'MOVING' || dstat[1] === 'HOMING') {
    move = dstat[1];
  } else {
    if (shutter === 'VENTED' || shutter === 'OPEN' || shutter === 'CLOSED') {
      move = 'IDLE';
    }
    if (shutter === 'CLOSING' || shutter === 'OPENING') {
      move = shutter;
    }
  }

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell><b>TCS</b></TableCell>
            <TableCell><b>Status</b></TableCell>
            <TableCell><b>Details</b></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow key='dome'>
            <TableCell>Dome</TableCell>
            <TableCell>{move}</TableCell>
            <TableCell>{`Azimuth: ${daz_deg}°`}</TableCell>
          </TableRow>
          <TableRow key='mount'>
            <TableCell>Mount</TableCell>
            <TableCell>{mount_state}</TableCell>
            <TableCell>
              <TableRow>
                <TableCell>{radec}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>{azalt}</TableCell>
              </TableRow>
            </TableCell>
          </TableRow>
          <TableRow key='cam'>
            <TableCell>Cam</TableCell>
            <TableCell>{cam_state}</TableCell>
            <TableCell>{acam_C_string}</TableCell>
          </TableRow>
        </TableBody>
      </Table>

    </TableContainer>

  );
}

export default Hardware;